<template>
  <div class="information" @keyup.enter="toshipping">
    <div v-if="!out_stock.length">
      <div class="row">
        <div class="col-12 informationtitle">
          <v-countdown v-if="count_down" :count_down="count_down" position="checkout"></v-countdown>
          <v-expresscheckout v-if="paypalposition=='information'||paypalposition=='both'" :pixel="pixel" :cartmes="cart"></v-expresscheckout>
          <h5 class="float-left">{{$t('shopping.contact_infomation')}}</h5>
          <p class="float-right" v-if="!user&&checkout_member_config!='guest'">
            {{$t('shopping.have_account')}}
            <a href="/account/login">{{$t('shopping.log_in')}}</a>
          </p>
        </div>
        <div class="col-md-12 userinfo" v-if="user">
          <div class="usertouxiang">
            <img src="../../../../../public/images/touxiang.png" alt />
          </div>
          <div class="shortinfo">
            <span>{{user.first_name}}</span>
            <span>{{user.last_name}}</span>
            <span>({{user.user_email}})</span>
            <div>
              <form id="logout-form" action="/logout" method="POST">
                <input type="hidden" name="_token" :value="token" />
                <a href="/" @click.prevent="logout">{{$t('shopping.log_out')}}</a>
              </form>
            </div>
          </div>
        </div>
        <div
          v-else
          class="col-md-12 nologin"
          :class="{
        'required':error,
        'had_input':shipping.email
      }"
        >
          <span>Email</span>
          <input
            type="email"
            v-model="shipping.email"
            @change="required"
            :placeholder="$t('shopping.email_address')"
            id="email"
          />
          <div>{{$t('shopping.enter_valid_email')}}</div>
        </div>
        <div v-if="checkout_edm_config!='hidden'" class="col-md-12 keepup">
          <label>
            <input type="checkbox" v-model="billing.subscribed" />
            <div
              class="iconfont icon-confirm-line"
              :class="billing.subscribed?'iskeepup':''"
              style="font-weight:600;"
            ></div>
            <span>{{$t('shopping.keep_me')}}</span>
          </label>
        </div>
      </div>
      <v-checkoutaddressform1
        v-if="this.shipping.country!='JP'"
        :service="myService"
        :cart="cart"
        :address_book="address_book"
        :user="user"
        :checkout_address_2_config="checkout_address_2_config"
        :checkout_phone_config="checkout_phone_config"
        :addressBook="addressoption"
        :information="shipping"
        ref="addressform"
        :complete="complete"
        @emailrequired="emailrequired"
        @upAddressBook="upAddressBook"
        @updataShipping="updataShipping"
      ></v-checkoutaddressform1>
      <v-checkoutaddressform2
        v-else
        :service="myService"
        :cart="cart"
        :address_book="address_book"
        :user="user"
        :checkout_address_2_config="checkout_address_2_config"
        :checkout_phone_config="checkout_phone_config"
        :addressBook="addressoption"
        :information="shipping"
        ref="addressform"
        :complete="complete"
        @emailrequired="emailrequired"
        @upAddressBook="upAddressBook"
        @updataShipping="updataShipping"
      ></v-checkoutaddressform2>
      <v-addressformfoot
        :toNext="$t('shopping.to_shipping')"
        toPrev="cart"
        ref="addressformfoot"
        @toNextApi="toshipping"
      ></v-addressformfoot>
    </div>
    <v-out-stock v-if="out_stock.length" :out_stock="out_stock"></v-out-stock>
    <v-checkoutcommonfoot :blogname="blogname"></v-checkoutcommonfoot>
  </div>
</template>
<script>
import vCheckoutaddressform1 from "./checkoutaddressform1";
import vCheckoutaddressform2 from "./checkoutaddressform2";
import vCheckoutcommonfoot from "./checkoutcommonfoot";
import vOutStock from "./out_stock";
import API from "../../../API.js";
import CountryStateJson from "../../../../assets/country_state.json";
import * as Sentry from "@sentry/browser";
export default {
  props: [
    "user",
    "service",
    "cart",
    "pixel",
    "address_book",
    "ga",
    "checkout_member_config",
    "checkout_address_2_config",
    "checkout_phone_config",
    "checkout_edm_config",
    "paypalposition",
    "complete",
    "blogname",
    "count_down",
  ],
  data() {
    return {
      myService:[],
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      error: false,
      shipping: {
        first_name: "",
        last_name: "",
        city: "",
        country: "",
        state: "",
        postcode: "",
        address_1: "",
        address_2: null,
        phone: null,
        email: "",
      },
      billing: {
        subscribed: this.checkout_edm_config == "checked",
      },
      addressoption: "newaddress",
      cart_list: [],
      out_stock: [],
      cart_hash:window.location.pathname.split('/')[2],
      utm_medium:null
    };
  },
  methods: {
    upAddressBook(upAddressBook) {
      this.addressoption = upAddressBook;
      console.log("addressoption", this.addressoption);
    },
    updataShipping(information) {
      console.log("information", information);
      this.shipping = information;
    },
    async toshipping() {
      this.$refs.addressformfoot.active = true;
      let value = this.$refs.addressform.toshipping();
      if (value) {
        try {
          this.$refs.addressform.error = {};
          this.utm_medium=this.getSearch('utm_medium');
          let address_data={
            cart_hash:this.cart_hash,
            shipping: this.shipping,
            billing: this.billing,
          };
          if(this.utm_medium){
            address_data.utm_medium=this.utm_medium;
          }
          let res = await this.$axios.post(API.address,address_data);
          console.log(res, this.shipping);
          if (res.data && res.data.address) {
            sessionStorage.setItem("address", JSON.stringify(res.data.address));
          }
          if (window.gtag) {
            gtag("event", "set_address", {
              event_category: "ecommerce",
            });
          }
          setTimeout(() => {
            this.$refs.addressformfoot.active = false;
          }, 5000);
          window.open(this.replaceSearch('step','shipping_method'), "_self");
        } catch (error) {
          this.$refs.addressformfoot.active = false;
          if (!this.$("title")[0].innerText.includes("Error")) {
            this.$("title")[0].innerText =
              "Error - " + this.$("title")[0].innerText;
          }
          if (error.response.data.status_code == 422) {
            this.$refs.addressform.error = error.response.data.errors;
            let error_id = Object.keys(error.response.data.errors);
            if (error_id.includes("shipping.email")) {
              this.error = true;
            }
            error_id = error_id[0].replace("shipping.", "");
            this.$refs.addressform.focusMethod(error_id);
          } else {
            this.$message.error(error.response.data.message);
          }
          // Sentry.captureException(error.response);
        }
      } else {
        this.$refs.addressformfoot.active = false;
      }
    },
    emailrequired() {
      this.error = true;
    },
    required(e) {
      let reg = /^([0-9A-Za-z\-_\.]+)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (e.target.value.trim() != "" && reg.test(e.target.value)) {
        this.error = false;
      } else {
        this.error = true;
      }
    },
    logout() {
      document.getElementById("logout-form").submit();
      localStorage.removeItem("isLogin");
    },
  },
  beforeMount() {
    let search=window.location.search;
    this.myService=this.concatCounty(this.service,CountryStateJson);
    // this.product_list = Object.values(this.cart.cart);
    // this.product_list.forEach(item => {
    //   let product = item.variant ? item.variant : item.product;
    //   if (
    //     product.manage_stock == "yes" &&
    //     product.backorders == "no" &&
    //     product.stock < item.quantity
    //   ) {
    //     this.out_stock.push(item);
    //   }
    // });
    // window.addEventListener(
    //   "pageshow",
    //   () => {
    //     this.$refs.addressformfoot.active = false;
    //   },
    //   false
    // );
    this.shipping.email = this.cart.address.email;
    // 如果在checkout页面填写过地址则使用填写过的地址，如果没有填写过地址则使用默认地址
    let address = sessionStorage.getItem("address");
    if (window.performance.navigation.type == 2 && address) {
      this.shipping = JSON.parse(address);
    }
    if (this.cart.address.first_name) {
      this.shipping = this.cart.address;
      if (!this.shipping.address_2) {
        this.shipping.address_2 = null;
      }
      //判断用户使用过的地址是否有匹配的地址薄的地址
      if (this.address_book.length) {
        this.address_book.some((item) => {
          if (
            this.shipping.first_name == item.first_name &&
            this.shipping.last_name == item.last_name &&
            this.shipping.city == item.city &&
            this.shipping.country == item.country &&
            this.shipping.state == item.state &&
            this.shipping.postcode == item.postcode &&
            this.shipping.address_1 == item.address_1 &&
            this.shipping.address_2 == item.address_2 &&
            this.shipping.phone == item.phone
          ) {
            this.addressoption = JSON.stringify(item);
            return true;
          }
        });
      }
    } else if (this.address_book.length) {
      this.address_book.some((item) => {
        if (item.default) {
          this.shipping = item;
          this.addressoption = JSON.stringify(item);
          return true;
        }
      });
    }
  },
  mounted() {
    this.$axios.post(API.statis_event, {
      name: "cart.information",
      parameters: { cart_hash: window.location.pathname.replace('/checkouts/','')}
    });
    console.log(this.cart);
    console.log(this.addressoption);
  },
  components: {
    vCheckoutcommonfoot,
    vCheckoutaddressform1,
    vCheckoutaddressform2,
    vOutStock,
  },
};
</script>
<style scoped lang='scss'>
.information {
  .informationtitle {
    h5 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
      margin: 0;
      color: #545454;
      a {
        text-decoration: none;
        color: #0f88a7;
      }
    }
  }
  .keepup {
    margin-top: 18px;
    label {
      cursor: pointer;
      span {
        font-size: 14px;
        color: #545454;
        line-height: 17px;
      }
    }

    div {
      display: inline-block;
      width: 17px;
      height: 17px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      line-height: 17px;
      text-align: center;
      color: white;
      font-size: 13px;
    }

    .iskeepup {
      background: #0f88a7;
      border: 1px solid #0f88a7;
    }

    input {
      display: none;
    }
  }

  .userinfo {
    margin-top: 25px;
    display: flex;
    align-items: center;

    .usertouxiang {
      width: 50px;
      height: 50px;
      overflow: hidden;
      border-radius: 10px;
      background-color: #d8d8d8;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .shortinfo {
      margin-left: 14px;
      flex: 1;
      font-size: 14px;
      color: #545454;
      span {
        word-break: break-all;
      }

      a {
        color: #128fae;
        text-decoration: none;
      }
    }
  }

  .nologin {
    margin-top: 10px;
    position: relative;
    input {
      outline: none;
      width: 100%;
      padding: 13px 11px;
      height: 46px;
      border-radius: 5px;
      font-size: 14px;
      border: 1px solid #d9d9d9;
      &:focus {
        border: 1px solid #0f88a7;
        box-shadow: 0 0 0 1px #0f88a7;
      }
    }
    div {
      color: red;
      display: none;
    }
    span {
      display: none;
      font-size: 12px;
      position: absolute;
      top: 5px;
      left: 27px;
    }
  }
  .had_input {
    select,
    input {
      padding: 21px 29px 5px 11px;
      font-size: 12px;
    }
    span {
      display: inline-block;
    }
  }

  .required {
    input {
      border-color: #e32c2b !important;
      box-shadow: 0 0 0 1px #e32c2b !important;
    }
    div {
      display: block;
    }
  }
}
@media screen and(max-width: 460px) {
  .information {
    p,
    h5 {
      float: none !important;
    }
  }
}
</style>